import Auth0 from 'auth0-js'
import EventEmitter from 'eventemitter3'
import { router } from './../router'
import store from '../store'

export default class AuthService {
  constructor () {
    this.auth0 = new Auth0.WebAuth({
      domain: process.env.AUTH0_DOMAIN,
      clientID: process.env.AUTH0_CLIENT_ID,
      redirectUri: store.state.config.AUTH0_CALLBACK_URL,
      responseType: 'id_token token'
    })
    this.authenticated = this.isAuthenticated()
    this.authNotifier = new EventEmitter()
    this.login = this.login.bind(this)
    this.setSession = this.setSession.bind(this)
    this.logout = this.logout.bind(this)
    this.isAuthenticated = this.isAuthenticated.bind(this)
  }

  login (isSignup) {
    this.auth0.authorize({
      connection: 'main-tenant-oidc',
      scope: 'openid profile email user_metadata',
      display: isSignup ? 'sup-active' : 'sup' // 'login' or 'forgotPassword'
      // mode: isSignup ? 'signUp' : 'login' // 'login' or 'forgotPassword'
    })
  }

  handleAuthentication () {
    this.auth0.parseHash({ hash: window.location.hash }, (err, authResult) => {
      if (err) {
        router.replace('splash')
        alert(`Error logging in.`)
      } else {
        this.setSession(authResult)
        router.push({name: 'Dash'})
      }
    })
  }

  setSession (authResult) {
    const siemensId = authResult.idTokenPayload['https://login.siemens.com/gid']
    const lastLogin = authResult.idTokenPayload['https://login.siemens.com/ll']
    store.commit('user/SET_TOKEN', authResult.idToken)
    store.commit('user/SET_SIEMENS_ID', siemensId) // add siemens id
    if (lastLogin) {
      store.commit('user/SET_LAST_LOGIN', {
        date: lastLogin.last_login,
        ip: lastLogin.last_ip,
        geo: lastLogin.last_geo
      })
    }

    // Set the time that the access token will expire at
    let expiresAt = authResult.idTokenPayload.exp * 1000

    localStorage.setItem('siemens_id', siemensId)
    localStorage.setItem('access_token', authResult.accessToken)
    localStorage.setItem('id_token', authResult.idToken)
    localStorage.setItem('expires_at', expiresAt)
    if (lastLogin) {
      localStorage.setItem('last_login', JSON.stringify({
        date: lastLogin.last_login,
        ip: lastLogin.last_ip,
        geo: lastLogin.last_geo
      }))
    }
    this.authNotifier.emit('authChange', { authenticated: true })
  }

  logout () {
    // Clear access token and ID token from local storage
    localStorage.removeItem('access_token')
    localStorage.removeItem('id_token')
    localStorage.removeItem('siemens_id')
    localStorage.removeItem('expires_at')
    localStorage.removeItem('jobSpecification')
    localStorage.removeItem('last_login')
    this.userProfile = null
    this.authNotifier.emit('authChange', false)

    var getUrl = window.location
    var baseUrl = getUrl.protocol + '//' + getUrl.host
    window.location = `https://${process.env.AUTH0_MAIN_DOMAIN}/v2/logout?returnTo=` +
      `${encodeURIComponent(`https://${process.env.AUTH0_DOMAIN}/v2/logout?returnTo=` +
      `${baseUrl}/logout&client_id=${process.env.AUTH0_CLIENT_ID}`)}`
  }

  isAuthenticated () {
    // Check whether the current time is past the
    // access token's expiry time
    let expiresAt = JSON.parse(localStorage.getItem('expires_at'))
    return new Date().getTime() < expiresAt
  }
}



// WEBPACK FOOTER //
// ./src/auth/AuthService.js